import LayoutAuthentication from './LayoutAuthentication.vue'
import LayoutDefault from './LayoutDefault.vue'
import LayoutNavBar from './LayoutNavBar.vue'
import LayoutPortal from './LayoutPortal.vue'
import LayoutSCT2 from './LayoutSCT2.vue'

export default {
  LayoutAuthentication,
  LayoutDefault,
  LayoutNavBar,
  LayoutPortal,
  LayoutSCT2,
}
